<template>
   <v-container>
      <div class="text-center">
         <v-row>
            <v-col cols="12">
               <v-card flat outlined class="pa-10">
                  <p>The page requested was not found</p>

                  <v-btn class="primary" @click="goHome">
                     <v-icon>mdi-home</v-icon>
                  </v-btn>
               </v-card>
            </v-col>
         </v-row>
      </div>
   </v-container>
</template>

<script>
export default {
   methods: {
      goHome() {
         this.$router.push({ name: "Home" });
      },
   },
};
</script>
